import { Image, Box, Grid, GridItem, Heading, Link, SimpleGrid, Text, Container, Stack, Button } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import parser from "html-react-parser";
import MotionBox from "./motion-box";
import cloudsBg from "../assets/images/cloud-background.png";
import axios from "axios";
import { apiHost } from "utils/Cons/Constants";

interface ImageType {
  link?: string;
  img?: string;
  title?: string;
  subtitle?: string;
}

const ExperiencesBlock = ({ page, block }) => {

    const [experiences, setExperiences] = useState([]);

    let firstImage: ImageType = {};
    let secondImage: ImageType = {};
    let thirdImage: ImageType = {};

    if (block.entry.images) {
        firstImage = block.entry.images[0];
        if (block.entry.images[1]) {
            secondImage = block.entry.images[1];
        }
        if (block.entry.images[2]) {
            thirdImage = block.entry.images[2];
        }
    }

    const getExperiences = () => {
        let data = [];
        axios.get(`${apiHost}/experiences/list`)
          .then(res => {
            data = res.data;
            if (res.status == 200) {
              setExperiences(data);
            }
            return res;
          })
          .catch(err => console.log(err));
    
        return data;
      };

      useEffect(() => {
        getExperiences();
      }, []);

    return (
        <Box backgroundImage={`url(${cloudsBg})`} backgroundPosition="top center" backgroundRepeat="no-repeat" backgroundSize="fit" marginTop="-350px" paddingTop="100px">
        <Container maxW={'6xl'}>
          <Stack
            textAlign={'center'}
            align={'center'}
            spacing={{ base: 8, md: 10 }}
            py={{ base: 10, md: 20 }}>
                <Heading
                    as={'h2'}
                    fontFamily="american"
                    fontWeight={600}
                    fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                    color="rgb(20, 59, 73)"
                    lineHeight={'100%'}
                    mt={{ base: 20, md: 20 }}>
                    <Text as={'div'} fontFamily="brush" fontWeight={500}
                        fontSize={{ base: '6rem', md: '8rem' }} color="rgb(20, 59, 73)" display="inline-block">
                        {block.title}
                    </Text>
                    {' '} Bellefonte
                </Heading>
            <SimpleGrid columns={{ base: 2, md: 4 }} spacing={10}>
              {experiences?.map((experience, index) => (
                <Box as={Link} href={`/experiences/${experience.slug}`} minWidth={{ base: 150, md: 200, lg: 220 }}>
                  <Image src={`${experience.main_image_url}`} p={5} alt={'experience image'} />
                  <Box pl={5} pr={5}>
                    <Link color="#D51F0C" fontWeight="bolder" fontSize="2.25rem" lineHeight="1.25em" textTransform="uppercase" fontFamily="american">{experience.name}</Link>
                  </Box>
                </Box>
              ))}
            </SimpleGrid>
            
          </Stack>

        </Container>
        <Container maxW={'8xl'}>
        <Box mb={20}>
                <SimpleGrid columns={{ base: 1, md: 2 }}>
                    <Box bg="#D51F0C" textAlign="left" pl={{ base: 10, md: 20 }} pr={{ base: 10, md: 40, lg: 80}} pb={10}>
                      <Heading
                          as={'h2'}
                          fontFamily="american"
                          fontWeight={600}
                          fontSize={{ base: '3xl', sm: '4xl', md: '6xl' }}
                          color="#fcefc9"
                          lineHeight={'100%'}
                          mt={{ base: 20, md: 20 }}>
                          <Text as={'div'} fontFamily="brush" fontWeight={500} mb={10}
                              fontSize={{ base: '4rem', md: '4rem', lg: '5rem' }} color="white">
                              {block.title}
                          </Text>
                          {' '} {block.entry.subtitle}
                      </Heading>
                      <Text color="white" fontSize="2xl" fontWeight="bold" mb={5}>{block.entry.text}</Text>
                      <Button as={Link} href={block.entry.link} bg="#fcefc9" color="black" fontSize="1xl" fontWeight="bold" mb={5} borderRadius={'1.25rem'}>{block.entry.button_text}</Button>
                    </Box>
                    <Box pt={5} ml={{ base: 0, md: -10, lg: -20, xl: -60}} mt={{ base: 0, md: 10 }} mb={-10} pr={{ base: 0, md: 5}}>
                        
                        <Grid templateColumns='repeat(12, 1fr)'>
                            <GridItem colSpan={7}>
                              <Link href={firstImage.link} _hover={{ opacity: 0.95 }}>
                                  <Box backgroundImage={`url(${firstImage.img})`} mr={5} borderRadius={10} backgroundPosition="center center" backgroundSize="cover" minHeight="550px" position="relative">
                                      <Heading textAlign="left" position="absolute" bottom="10px" left="20px" color="white" textShadow="0px 0px 5px #000" lineHeight="1em">{firstImage.title}</Heading>
                                      <Text fontSize="2xl" textAlign="left" position="absolute" bottom="10px" left="20px" color="white">{firstImage.subtitle}</Text>
                                  </Box>
                              </Link>
                            </GridItem>
                            <GridItem colSpan={5}>
                                <Link href={secondImage.link} _hover={{ opacity: 0.8 }}>
                                    <Box pt={5}>
                                        <Box borderRadius={10} backgroundImage={`url(${secondImage.img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="250px" position="relative">
                                            <Heading textAlign="left" position="absolute" bottom="10px" left="20px" color="white" textShadow="0px 0px 5px #000" lineHeight="1em">{secondImage.title}</Heading>
                                            <Text fontSize="2xl" textAlign="left" position="absolute" bottom="10px" left="20px" color="white">{secondImage.subtitle}</Text>
                                        </Box>
                                    </Box>
                                </Link>
                                <Link href={thirdImage.link} _hover={{ opacity: 0.8 }}>
                                    <Box pt={5}>
                                        <Box borderRadius={10} backgroundImage={`url(${thirdImage.img})`} backgroundPosition="center center" backgroundSize="cover" minHeight="250px" position="relative">
                                            <Heading textAlign="left" position="absolute" bottom="10px" left="20px" color="white" textShadow="0px 0px 5px #000" lineHeight="1em">{thirdImage.title}</Heading>
                                            <Text fontSize="2xl" textAlign="left" position="absolute" bottom="10px" left="20px" color="white">{thirdImage.subtitle}</Text>
                                        </Box>
                                    </Box>
                                </Link>
                            </GridItem>
                        </Grid>
                    </Box>
                </SimpleGrid>
            </Box>
            </Container>
      </Box>
    )
};

export default ExperiencesBlock;